import React, { useState, useEffect, useContext } from "react";

// Package Import
import {
  Typography,
  Box,
  useTheme,
  TextField,
  Button,
  Grid,
  Paper,
  MenuItem,
  Backdrop,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { formControlClasses } from "@mui/material/FormControl";
import { Form, Formik } from "formik";
import DatePicker from "react-datepicker";

// User Import

import {
  BATCH_MAIN_TYPES_ENUM_ARRAY,
  USER_ROLES_ENUM,
  BATCH_CREATE_ENUMS,
  BATCH_SUB_TYPES_ENUM_ARRAY,
  RequestEnumArr,
  TEMPRATURE_TYPES_ENUM_ARRAY,
  TEMPRATURE_ENUM_ARRAY,
} from "../../../../common/Enums";
import { MINISTRY_API_ULRS } from "../../../../Services/Routes/API";
import { headersPost } from "../../../../Services/API";
import { RoutesUrls } from "../../../../Services/Routes/APP";
import { CustomDateInput } from "../../../../common/Components";
import { ministry_Context } from "../../../../context";
import { transferBatchSchema1 } from "../../../../Services/validations/MinistryPortal/Batch";

// Constant

const initialValues = {
  type: "request",
  main_type: "",
  sub_type: "",
  batch_type: "",
  parent_batch_id: "",
  reference_number: "",
  // storage_temperature: "",
  // temperature_unit: "",
  dispatch_date: "",
  // expiry_date: "",
  quantity: "",
  receiver_name: "",
  receiver_id: "",
  note: "",
};

// Component

const IssuedBatch = () => {
  // Hooks

  const theme = useTheme();
  const navigate = useNavigate();
  const { state } = useLocation();

  const { provinces } = useContext(ministry_Context);

  //states

  const [formValue, setFormValue] = useState(initialValues);
  const [open, setOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [recieverArr, setRecieverArr] = useState([]);
  const [batchArr, setBatchArr] = useState([]);
  const [mainTypeValue, setMainTypeValue] = useState("");
  const [subTypeValue, setSubTypeValue] = useState("");

  //form submit handler

  const formSubmitHanlder = (values) => {
    const data = {
      batch: {
        request_id: state?.request_data?.id,
        type: values.type,
        main_type: values.main_type,
        sub_type: values.sub_type,
        reference_number: values.reference_number,
        storage_temperature: values.storage_temperature,
        // expiry_date: values.expiry_date,
        size: values.quantity,
        previous_temperature: values.previous_temperature,
        modifier_date: values.modifier_date,
        batch_type: values.batch_type,
        parent_batch_id: values?.parent_batch_id,
        receiver_id: values.receiver_id,
        receiver_name: values?.receiver_name,
        action: BATCH_CREATE_ENUMS.TRANSFER,
        delivery_date: values?.delivery_date,
        note: values?.note,
      },
    };

    setOpen(true);

    headersPost(MINISTRY_API_ULRS.APPROVE_REQUEST, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          navigate(-2);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };
  useEffect(() => {
    getTypeHandler1();
  }, [subTypeValue, mainTypeValue]);

  const getTypeHandler1 = () => {
    if (subTypeValue && mainTypeValue) {
      const data = {
        batch: {
          main_type: mainTypeValue,
          sub_type: subTypeValue,
        },
      };
      setOpen(true);

      headersPost(MINISTRY_API_ULRS.REQUEST_BATCH_LISTINGS, data)
        .then((res) => {
          setOpen(false);
          if (res?.status === 200 && res?.data?.success) {
            setBatchArr(res?.data?.batches);
          } else {
            setAlertOpen(true);
            setAlertMsg(res?.data?.message);
            setAlertIcon("warning");
          }
        })
        .catch((err) => {
          setOpen(false);
          const { response } = err;
          if (response?.status === 401) {
            localStorage.clear();
            navigate(RoutesUrls?.root);
          } else {
            setAlertOpen(true);
            setAlertMsg(response?.statusText);
            setAlertIcon("error");
          }
        });
    } else return;
  };

  // const getTypeHandler = (type) => {
  //   const data = {
  //     requests: {
  //       request_type: type,
  //     },
  //   };
  //   setOpen(true);

  //   headersPost(MINISTRY_API_ULRS.REQUEST_INVENTORY, data)
  //     .then((res) => {
  //       setOpen(false);
  //       if (res?.status === 200 && res?.data?.success) {
  //         setRecieverArr(res?.data?.receiver);
  //       } else {
  //         setAlertOpen(true);
  //         setAlertMsg(res?.data?.message);
  //         setAlertIcon("warning");
  //       }
  //     })
  //     .catch((err) => {
  //       setOpen(false);
  //       const { response } = err;
  //       if (response?.status === 401) {
  //         localStorage.clear();
  //         navigate(RoutesUrls?.root);
  //       } else {
  //         setAlertOpen(true);
  //         setAlertMsg(response?.statusText);
  //         setAlertIcon("error");
  //       }
  //     });
  // };
  // set form initial values

  useEffect(() => {
    state?.request_data?.id &&
      setFormValue((prev) => ({
        ...prev,
        // parent_batch_id: state?.request_data?.id,
        size: state?.request_data?.available_quantity,
        batch_type: state?.request_data.sender_role,
        quantity: state?.request_data?.quantity,
        receiver_id: state?.request_data.sender_id,
        receiver_name: state?.request_data.sender_name,
        expiry_date: state?.request_data?.expiry_date,
        modifier_date: state?.request_data?.modifier_date,
      }));
    return () => {
      setFormValue(initialValues);
    };
  }, [state?.request_data]);

  //close alert

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };

  // Render

  return (
    <Paper
      sx={{
        p: 2,
        margin: "auto",

        borderRadius: 2,
      }}
    >
      <Box padding={2}>
        <Typography
          width={"100%"}
          variant="h5"
          fontWeight={"bold"}
          display={"flex"}
          justifyContent={"left"}
          color={"text.grayText"}
          sx={{
            textTransform: "uppercase",
            paddingBottom: 2,
          }}
        >
          Transfer Inventory
        </Typography>
        <Formik
          initialValues={formValue}
          onSubmit={formSubmitHanlder}
          validationSchema={transferBatchSchema1}
          enableReinitialize
        >
          {({
            values,
            touched,
            errors,
            handleChange,
            handleSubmit,
            setFieldValue,
          }) => (
            <Form onSubmit={handleSubmit}>
              <Box padding={{ xs: 0, sm: 3, md: 5 }}>
                <Grid
                  container
                  justifyContent={"space-around"}
                  spacing={2}
                  margin={"auto"}
                >
                  <Grid container marginBottom={5} spacing={{ xs: 3, sm: 4 }}>
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <TextField
                        variant="outlined"
                        size={"small"}
                        type={"text"}
                        name="main_type"
                        value={values.main_type}
                        select
                        error={touched?.main_type && Boolean(errors?.main_type)}
                        helperText={touched?.main_type && errors?.main_type}
                        fullWidth
                        SelectProps={{
                          displayEmpty: true,
                        }}
                        onChange={(e) => {
                          setMainTypeValue(e.target.value);
                          handleChange(e);
                        }}
                        sx={{
                          border: "1px solid grey",
                          [`& .${outlinedInputClasses?.root}`]: {
                            borderRadius: theme.spacing(1),
                          },
                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                        }}
                      >
                        <MenuItem value={""} disabled>
                          Select an inventory type
                        </MenuItem>
                        {BATCH_MAIN_TYPES_ENUM_ARRAY?.map((item, index) => (
                          <MenuItem
                            value={item.value}
                            key={`${index}-request-inventory-${item.value}`}
                          >
                            {item.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <TextField
                        variant="outlined"
                        size={"small"}
                        type={"text"}
                        name="sub_type"
                        value={values.sub_type}
                        select
                        fullWidth
                        SelectProps={{
                          displayEmpty: true,
                        }}
                        onChange={(e) => {
                          setSubTypeValue(e.target.value);
                          handleChange(e);
                        }}
                        error={touched?.sub_type && Boolean(errors?.sub_type)}
                        helperText={touched?.sub_type && errors?.sub_type}
                        sx={{
                          border: "1px solid grey",
                          [`& .${outlinedInputClasses?.root}`]: {
                            borderRadius: theme.spacing(1),
                          },
                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                        }}
                      >
                        <MenuItem value={""} disabled>
                          Select an Category
                        </MenuItem>
                        {BATCH_SUB_TYPES_ENUM_ARRAY?.map((item, index) => (
                          <MenuItem
                            value={item.value}
                            key={`${index}-request-inventory-${item.value}`}
                          >
                            {item.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <TextField
                        variant="outlined"
                        size={"small"}
                        fullWidth
                        select
                        SelectProps={{
                          displayEmpty: true,
                        }}
                        name="parent_batch_id"
                        type={"text"}
                        onChange={handleChange}
                        value={values?.parent_batch_id}
                        error={
                          touched?.parent_batch_id &&
                          Boolean(errors?.parent_batch_id)
                        }
                        helperText={
                          touched?.parent_batch_id && errors?.parent_batch_id
                        }
                        sx={{
                          border: "1px solid grey",
                          [`& .${outlinedInputClasses?.root}`]: {
                            borderRadius: theme.spacing(1),
                          },
                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                        }}
                      >
                        <MenuItem value={""} disabled>
                          Select Batch
                        </MenuItem>
                        {batchArr?.map((item, index) => (
                          <MenuItem
                            key={`${index}-request-${item.id}`}
                            value={item.id}
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography component={"span"}>
                              {item.reference_number}
                            </Typography>

                            <Typography sx={{}} component={"span"}>
                              Available Quantity: {item?.available_quantity}
                            </Typography>
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <TextField
                        variant="outlined"
                        size={"small"}
                        fullWidth
                        name="reference_number"
                        type={"text"}
                        onChange={handleChange}
                        value={values?.reference_number}
                        error={
                          touched?.reference_number &&
                          Boolean(errors?.reference_number)
                        }
                        helperText={
                          touched?.reference_number && errors?.reference_number
                        }
                        placeholder={"Please enter new batch no"}
                        sx={{
                          border: "1px solid grey",
                          [`& .${outlinedInputClasses?.root}`]: {
                            borderRadius: theme.spacing(1),
                          },
                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                        }}
                      ></TextField>
                    </Grid>
                    {/* <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <TextField
                        variant="outlined"
                        size={"small"}
                        type={"text"}
                        name="sub_type"
                        value={values?.sub_type}
                        select
                        fullWidth
                        SelectProps={{
                          displayEmpty: true,
                        }}
                        onChange={handleChange}
                        sx={{
                          border: "1px solid grey",
                          [`& .${outlinedInputClasses?.root}`]: {
                            borderRadius: theme.spacing(1),
                          },
                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                        }}
                      >
                        <MenuItem value={""} disabled>
                          Temprature Unit
                        </MenuItem>
                        {TEMPRATURE_TYPES_ENUM_ARRAY?.map((item, index) => (
                          <MenuItem
                            value={item.value}
                            key={`${index}-request-inventory-${item.value}`}
                          >
                            {item.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid> */}

                    {/* <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <TextField
                        variant="outlined"
                        size={"small"}
                        type={"text"}
                        name="storage_temperature"
                        value={values?.storage_temperature}
                        select
                        fullWidth
                        SelectProps={{
                          displayEmpty: true,
                        }}
                        onChange={handleChange}
                        sx={{
                          border: "1px solid grey",
                          [`& .${outlinedInputClasses?.root}`]: {
                            borderRadius: theme.spacing(1),
                          },
                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                        }}
                      >
                        <MenuItem value={""} disabled>
                          Storage Temprature
                        </MenuItem>
                        {TEMPRATURE_ENUM_ARRAY?.map((item, index) => (
                          <MenuItem
                            value={item.value}
                            key={`${index}-request-inventory-${item.value}`}
                          >
                            {item.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid> */}
                    {/* <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <DatePicker
                        selected={values.expiry_date}
                        onChange={(date) => setFieldValue("expiry_date", date)}
                        minDate={new Date()}
                        selectsStart
                        placeholderText="Please select Expiry date"
                        name="expiry_date"
                        customInput={
                          <CustomDateInput
                            size={"small"}
                            name={"expiry_date"}
                            InputProps={{
                              readOnly: true,
                            }}
                            helperText={
                              touched?.expiry_date && errors?.expiry_date
                            }
                            error={
                              touched?.expiry_date &&
                              Boolean(errors?.expiry_date)
                            }
                          />
                        }
                      />
                    </Grid> */}

                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <DatePicker
                        selected={values.dispatch_date}
                        onChange={(date) =>
                          setFieldValue("dispatch_date", date)
                        }
                        minDate={new Date()}
                        selectsStart
                        placeholderText="Please select dispatch date"
                        name="dispatch_date"
                        customInput={
                          <CustomDateInput
                            size={"small"}
                            name={"dispatch_date"}
                            InputProps={{
                              readOnly: true,
                            }}
                            helperText={
                              touched?.dispatch_date && errors?.dispatch_date
                            }
                            error={
                              touched?.dispatch_date &&
                              Boolean(errors?.dispatch_date)
                            }
                          />
                        }
                      />
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <TextField
                        variant="outlined"
                        size={"small"}
                        type={"number"}
                        name="quantity"
                        disabled
                        // onChange={handleChange}
                        error={touched?.quantity && Boolean(errors?.quantity)}
                        helperText={touched?.quantity && errors?.quantity}
                        value={values.quantity}
                        placeholder="Please enter batch quantity"
                        fullWidth
                        sx={{
                          border: "1px solid grey",
                          borderRadius: theme.spacing(1),

                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                          [`& .${outlinedInputClasses?.root}`]: {
                            // backgroundColor: `${theme.palette.secondary.dark}`,
                            borderRadius: theme.spacing(1),
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <TextField
                        variant="outlined"
                        size={"small"}
                        fullWidth
                        disabled
                        // select
                        // SelectProps={{
                        //   displayEmpty: true,
                        // }}
                        name="batch_type"
                        // onChange={(e) => {
                        //   getTypeHandler(e.target.value);
                        //   setFieldValue("batch_type", e.target.value);
                        // }}
                        type={"text"}
                        value={values?.batch_type}
                        error={
                          touched?.batch_type && Boolean(errors?.batch_type)
                        }
                        helperText={touched?.batch_type && errors?.batch_type}
                        placeholder="Select Type"
                        sx={{
                          border: "1px solid grey",
                          [`& .${outlinedInputClasses?.root}`]: {
                            borderRadius: theme.spacing(1),
                          },
                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                        }}
                      >
                        {/* <MenuItem value={""} disabled>
                          Select a Request Type{" "}
                        </MenuItem>
                        {RequestEnumArr?.map((item, index) => (
                          <MenuItem
                            key={`${index}-request-${item.value}`}
                            value={item.value}
                          >
                            {item.name}{" "}
                          </MenuItem>
                        ))} */}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <TextField
                        variant="outlined"
                        size={"small"}
                        fullWidth
                        disabled
                        // select
                        // SelectProps={{
                        //   displayEmpty: true,
                        // }}
                        name="receiver_name"
                        // onChange={handleChange}
                        type={"text"}
                        value={values?.receiver_name}
                        error={
                          touched?.receiver_name &&
                          Boolean(errors?.receiver_name)
                        }
                        helperText={
                          touched?.receiver_name && errors?.receiver_name
                        }
                        sx={{
                          border: "1px solid grey",
                          [`& .${outlinedInputClasses?.root}`]: {
                            borderRadius: theme.spacing(1),
                          },
                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                        }}
                      >
                        {/* <MenuItem value={""} disabled>
                          Select a reciever to
                        </MenuItem>
                        {recieverArr?.map((item, index) => (
                          <MenuItem
                            key={`${index}-request-${item.id}`}
                            value={item.id}
                          >
                            {item.name}{" "}
                          </MenuItem>
                        ))} */}
                      </TextField>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <TextField
                        variant="outlined"
                        size={"small"}
                        rows={3}
                        type={"text"}
                        name="note"
                        onChange={handleChange}
                        value={values.note}
                        multiline
                        placeholder="Batch Description"
                        fullWidth
                        sx={{
                          border: "1px solid grey",
                          borderRadius: theme.spacing(1),

                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                          [`& .${outlinedInputClasses?.root}`]: {
                            // backgroundColor: `${theme.palette.secondary.dark}`,
                            borderRadius: theme.spacing(1),
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                  {/* Button */}
                  <Grid container>
                    <Grid
                      container
                      marginTop={5}
                      display={"flex"}
                      justifyContent={"right"}
                    >
                      <Button
                        variant="contained"
                        type="submit"
                        size="large"
                        margin={"auto"}
                        sx={{
                          borderRadius: 2,
                          minWidth: "20%",
                        }}
                      >
                        {" "}
                        Done{" "}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        color={alertIcon}
        autoHideDuration={100000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={alertIcon} color={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default IssuedBatch;
